export default {
    topics: [
        {
            title: ' description ',
            href: 'p-EnumerationValue-description.html',
            attributes: { 'data-id': 'p-EnumerationValue-description' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-description-d66e6668',
            topics: [],
        },
        {
            title: ' enabledIf ',
            href: 'p-EnumerationValue-enabledIf.html',
            attributes: { 'data-id': 'p-EnumerationValue-enabledIf' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-enabledIf-d66e6676',
            topics: [],
        },
        {
            title: ' image ',
            href: 'p-EnumerationValue-image.html',
            attributes: { 'data-id': 'p-EnumerationValue-image' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-image-d66e6684',
            topics: [],
        },
        {
            title: ' label ',
            href: 'p-EnumerationValue-label.html',
            attributes: { 'data-id': 'p-EnumerationValue-label' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-label-d66e6692',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-EnumerationValue-name.html',
            attributes: { 'data-id': 'p-EnumerationValue-name' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-name-d66e6700',
            topics: [],
        },
        {
            title: ' value ',
            href: 'p-EnumerationValue-value.html',
            attributes: { 'data-id': 'p-EnumerationValue-value' },
            menu: { hasChildren: false },
            tocID: 'p-EnumerationValue-value-d66e6708',
            topics: [],
        },
    ],
};

